import smoothScroll from '../../js/lib/smoothScrollTo';
import request from '../../js/lib/request';
import currentLang from '../../js/lib/currentLang';
import envVar from '../../js/lib/envVar';
import urlVars from '../../js/lib/urlVars';
import eventBus from '../../js/lib/eventBus';


const pagination = document.querySelector('.pagination');
if(pagination){
	const scroll = new smoothScroll('a[href*="#"]',{
		offset: -80,
	});
}

const bTopic = document.getElementById('browseByTopic');

const urlTopics = [];
const urlSubtopics = [];

if (bTopic) {
	const topicUrl = envVar({
		backendPath: '/browsebytopicpage/opentopic?topicid=' // pass the id to us
	});

	var SubtopicComponent = {
		template: '#subtopic-template',
		props: {
			category: {
				type: Object,	
			},
			topicid: {
				type: Number,	
			},
			subsToLoad: {
				type: Array,	
			},
			metricsid: {
				type: String,	
			},
		},
		data() {
			return {
				subtopics: '',
				subTopicLoading: '',
				alreadyLoaded: [],
			};
		},
		mounted: function() {
			const self = this;

			if (self.subsToLoad && self.subsToLoad.length > 0) {

				self.alreadyLoaded = [];
				for (var x = 0; x < self.subsToLoad.length; x++) 
				{
					var foundAlready = false;
					for (var y = 0; y < self.alreadyLoaded.length; y++) 
					{
						if(self.alreadyLoaded[y] == self.category.key)	
							foundAlready = true;
					}

					if (self.subsToLoad[x] == self.category.key && !foundAlready) 
					{
						self.$refs['subtopicLink'].click();
						self.alreadyLoaded.push(self.category.key);
					}
				}
			}
		},
		methods: {
			loadSubtopics: function(event, catid) {
				const self = this;

				// always refresh subs
				const subtopicUrl = envVar({
					backendPath: `/browsebytopicpage/opensubtopic?topicid=${self.topicid}&catid=${catid}&metricsid=${self.metricsid}&lang=${currentLang()}` // pass the id to us
				});

				self.subtopics = '';

				if(self.toggleDropdown(event))
				{
					self.subTopicLoading = true;
					request().get(subtopicUrl).then(function(response) {
						self.subtopics = response;
						self.subTopicLoading = false;

						urlSubtopics.push(catid);
					});
				}
				else
				{
					for (var x = 0; x < urlSubtopics.length; x++)
					{ 
						if(urlSubtopics[x] == catid)
							urlSubtopics.splice(x, 1);
					}
				}
			},
			loadUrl: function(url) {
				window.history.pushState(null, '', '?t=' + urlTopics.join() + '&s=' + urlSubtopics.join());

				document.location.href = url;
			},
			loadMore: function(lang) {
				const self = this;
				window.history.pushState(null, '', '?t=' + urlTopics.join() + '&s=' + urlSubtopics.join());

				document.location.href = '/' + lang + '/search/?c=' + self.category.key + '&c2=' + self.topicid;
			},
			toggleDropdown: function (event) {
				const elementToOpen = event.currentTarget.parentElement;

				if (elementToOpen.dataset.open === 'true') {
					// Close dropdown
					elementToOpen.removeAttribute('data-open');
					elementToOpen.blur();
					return false;
				} else {
					// Open dropdown
					elementToOpen.setAttribute('data-open', true);
					elementToOpen.focus();
					return true;
				}
			},
		}
	};

	// Vue Component
	var TopicComponent = {
		template: '#topic-template',
		components: {
			'subtopic-component': SubtopicComponent,
		},
		props: {
			topicid: {
				type: Number,	
			},
			topicvalue: {
				type: String,	
			},
			metricsid: {
				type: String,	
			},
		},
		data() {
			return {
				subsToLoad: [],
				topic: '',
				topicLoading: '',
				subTopicLoading: '',
			};
		},
		mounted: function() {
			const self = this;

			eventBus.$on('loadTopic', (t, s) => {
				for (var x = 0; x < t.length; x++) 
				{
					if (self.topicid == t[x]) {
						self.$refs['topicLink'].click();

						self.subsToLoad = s;
					}
				}
			});
		},
		// Methods
		methods: {
			loadTopic: function(event) {
				const self = this;

				if(self.toggleDropdown(event))
				{
					// Load only once; cache original results
					if(self.topic.length === 0) {
						self.topicLoading = true;
						request().get(topicUrl + self.topicid + '&metricsid=' + self.metricsid + '&lang=' + currentLang()).then(function(response) {
							self.topic = response;
							self.topicLoading = false;

							// push to url
							urlTopics.push(self.topicid);
						});
					}
				}
				else
				{
					for (var x = 0; x < urlTopics.length; x++)
					{ 
						if(urlTopics[x] == self.topicid)
							urlTopics.splice(x, 1);
					}
				}
			},
			toggleDropdown: function (event) {
				const elementToOpen = event.currentTarget.parentElement;

				if (elementToOpen.dataset.open === 'true') {
					// Close dropdown
					elementToOpen.removeAttribute('data-open');
					elementToOpen.blur();
					return false;
				} else {
					// Open dropdown
					elementToOpen.setAttribute('data-open', true);
					elementToOpen.focus();
					return true;
				}
			},
		}
	};

	const browse = new Vue({
		el: '#browseByTopic',
		components: {
			'topic-component': TopicComponent,
		},
		mounted: function() {
			// remove the hashtags from the array
			var remPound = /#[A-Za-z]/;
			var qs = urlVars();
			if(qs['t'])
				eventBus.$emit('loadTopic', qs['t'].split(','), qs['s'].replace(remPound, '').split(','));
		},
	});
}



// WEBPACK FOOTER //
// ../components/topic/topic.js